import * as React from "react";
import * as styles from "./styles.scss";

import {
  Input,
  Icon,
  Dropdown
} from "../../components";

interface DropDownItem {
  id: any;
  title: any;
}

interface IProps {
  title?: any;
  dropdownText?: any;
  onChange?: any;
  onSearch?: any;
  dropDownItems?: DropDownItem[];
  searchPlaceholder?: string;
  isSearchDisabled?: boolean;
}

interface IState {
  isSearchMode: boolean;
  inputValue: string;
}

export class CardSearchHeader extends React.Component<IProps, IState> {
  public state = {
    isSearchMode: false,
    inputValue: ""
  };

  private toogleSearchMode = () => {
    const { isSearchMode } = this.state;

    this.setState({
      isSearchMode: !isSearchMode
    });
  };

  private handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    this.setState({
      inputValue
    });
  };

  private handlerSearch = async () => {
    const isClose = await this.props.onSearch(this.state.inputValue);

    if (isClose) {
      this.setState({
        isSearchMode: false
      });
    }
  };

  render() {
    const {
      title,
      onChange,
      dropdownText,
      dropDownItems,
      searchPlaceholder,
      isSearchDisabled
    } = this.props;
    const { isSearchMode, inputValue } = this.state;

    const headerMain = (
      <>
        <div className={styles.headerWithTags}>{title}</div>
        <div className={styles.headerTags}>{this.props.children}</div>
        <div className={styles.headerWithTagsPad}>
          <Dropdown title={dropdownText} onChange={onChange}>
            {dropDownItems.map(({ id, title }) => (
              <Dropdown.Item key={id} id={id}>
                {title}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </div>
        {isSearchDisabled || (
          <div className={styles.searchIcon}>
            <Icon name="search" size={17} onClick={this.toogleSearchMode} />
          </div>
        )}
      </>
    );

    const headerSearch = (
      <>
        <div className={styles.headerFull}>
          <div
            className={`${styles.searchIcon} ${styles.searchIconLeft}`}
            onClick={this.handlerSearch}
          >
            <Icon name="search" size={17} />
          </div>
          <div className={styles.searchInput}>
            <Input
              placeholder={searchPlaceholder}
              search=""
              fullWidth
              value={inputValue}
              onChange={this.handleInputChange}
            />
          </div>
          <div className={styles.closeIcon}>
            <Icon name="close" size={17} onClick={this.toogleSearchMode} />
          </div>
        </div>
      </>
    );

    return (
      <div className={styles.header}>
        {isSearchMode ? headerSearch : headerMain}
      </div>
    );
  }
}
